import Prescriptions from './prescriptions';

export default Prescriptions;
